import React ,{useState} from 'react';
import './index.css';
import {Gamepage} from './gamepage';
const Mainpage = () => {
    const[click,useclick]=useState(false);
    const clicked=()=>{
        useclick(true);
    }
        if(click)
        {
            return(
                <Gamepage/>
            )
        }
        else{
  return (
    <div>
        <div className='row mainpage'>
            <div className='col-md-6'>
        <img className="firstpage"src="./images/dices.png"alt="firstpicture"/>
        </div>
        <div className='col-md-6 max-md:tw-w-[100vw]  dice-game d-flex align-items-center justify-content-center'>
            <div>
        <h1 className='gamename text-center'>DICE GAME</h1>
        <input type="button" className="play_now"value="Play Now"onClick={clicked}/>
        </div>
        </div>
        </div>
        
    </div>
        
  )
    
}

}

export default Mainpage